export type ILocationState = {
    id: number;
    address: string;
    center_location: string;
    name: string;
    polygon_locations: null
}

export enum ILocationActionTypes {
    FETCH_LOCATION_LIST_REQUEST = 'FETCH_LOCATION_LIST_REQUEST',
    FETCH_LOCATION_LIST_SUCCESS = 'FETCH_LOCATION_LIST_SUCCESS',
    FETCH_LOCATION_LIST_FAILURE = 'FETCH_LOCATION_LIST_FAILURE',

}

export type ILocationActionCreator = {
    type: string;
    payload: ILocationState;
  };
